/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface ExchangeLeadResponse
 */
export interface ExchangeLeadResponse {
    /**
     * 
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead;
}

/**
 * Check if a given object implements the ExchangeLeadResponse interface.
 */
export function instanceOfExchangeLeadResponse(value: object): value is ExchangeLeadResponse {
    return true;
}

export function ExchangeLeadResponseFromJSON(json: any): ExchangeLeadResponse {
    return ExchangeLeadResponseFromJSONTyped(json, false);
}

export function ExchangeLeadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeLeadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON(json['data']),
    };
}

export function ExchangeLeadResponseToJSON(json: any): ExchangeLeadResponse {
    return ExchangeLeadResponseToJSONTyped(json, false);
}

export function ExchangeLeadResponseToJSONTyped(value?: ExchangeLeadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON(value['data']),
    };
}

